import React, { useEffect, useState, Suspense, lazy } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchOrganiserEvents } from "../redux/eventOrganiserThunks";
import userStore from "../../../zustand/userStore";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
import { setSelectedEvent } from "../redux/eventOrganiserSlice";
import moment from "moment";
import { e } from "mathjs";
import { filterEventsForUser } from "./utils";
import "./events-responsive.css";
import { setAppdAiUser } from "../../../utils/appdAiHelpers";

const ShowAll = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const events = useSelector((state) => state.eventOrganiser.Events) || [];
  const [processedEvents, setProcessedEvents] = useState([]);

  useEffect(() => {
    if (userData?.roles === "user") {
      // dispatch(fetchOrganiserEvents({ userId: 1 })); commented by srinu for new user part 09/06/26
      dispatch(fetchOrganiserEvents({ userId: userData?.parent_sub_id }));
    } else if (userData?.id) {
      dispatch(fetchOrganiserEvents({ userId: userData.id }));
    }
  }, [dispatch, userData]);

  // useEffect(() => {
  //   // if (userData) setAppdAiUser(userData, "View Events");
  //   if (userData) setAppdAiUser(userData, "demo");
  // }, []);

  const dataTableColumns = [
    {
      Header: "#",
      accessor: "sno",
    },
    {
      Header: "Event Name",
      accessor: "name",
    },
    // {
    //   Header: "Date",
    //   accessor: "date",
    // },
    {
      Header: "Start Time",
      accessor: "start_time",
    },
    {
      Header: "End Time",
      accessor: "end_time",
    },
    // {
    //   Header: "Actions",
    //   accessor: "actiontd",
    // },
  ];

  const processData = (eventsArray) => {
    return eventsArray.map((event, index) => {
      return {
        ...event,
        sno: index + 1,
        name: (
          <span
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              console.log("Selected event being passed:", event);
              dispatch(setSelectedEvent(event));
              navigate("/eventNotes", { state: { event } });
            }}
          >
            {event.name}
          </span>
        ),
        // issue: event.start_time/end_time can be a time-only string like "16:19" which isn't ISO/RFC2822 → moment() logs a deprecation warning and falls back to new Date(). Pass explicit accepted formats so moment parses without warning.
        start_time: moment(event.start_time, [
          "HH:mm",
          "HH:mm:ss",
          moment.ISO_8601,
          moment.RFC_2822,
        ]).format("DD-MM-YYYY HH:mm:ss"),
        end_time: moment(event.end_time, [
          "HH:mm",
          "HH:mm:ss",
          moment.ISO_8601,
          moment.RFC_2822,
        ]).format("DD-MM-YYYY HH:mm:ss"),

        actiontd: (
          <>
            {/* <i
              data-tip="View Event"
              title="View Event"
              className="fa fa-eye mx-2"
              style={{ color: "blue", cursor: "pointer" }}
              aria-hidden="true"
              onClick={() => {
                // alert("~" + event.name);
                dispatch(setSelectedEvent(event));
                navigate("/eventNotes", {
                  state: { event },
                });
              }}
            ></i> */}
          </>
        ),
      };
    });
  };

  // const filteredEvents = filterEventsForUser(
  //   events,
  //   userData?.id,
  //   userData?.roles
  // );
  // const processedEvents = processData(filteredEvents);
  // issue: inline processing creates a new array ref every render → `AllFeatureDataTable` (react-table v7 useTable) kept re-initializing → "Maximum update depth exceeded" infinite loop. Store processed data in state so the reference is stable and only updates when inputs change.
  useEffect(() => {
    const filteredEvents = filterEventsForUser(
      events,
      userData?.id,
      userData?.roles
    );
    setProcessedEvents(processData(filteredEvents));
  }, [events, userData?.id, userData?.roles]);

  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="events-page-wrapper main_container px-5">
        {/* <Sidebar />
        <Navbar /> */}
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <div className="clearfix">
                    {userData?.roles !== "user" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          // marginBottom: "20px",
                        }}
                      >
                        <button
                          className="btn btn-primary btn-sm"
                          style={{
                            borderStyle: "none",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                          onClick={() => navigate("/addEvent")}
                        >
                          Add Event
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="x_content">
                  {processedEvents.length > 0 ? (
                    <div className="table-responsive">
                      <AllFeatureDataTable
                        columns={dataTableColumns}
                        data={processedEvents}
                      />
                    </div>
                  ) : (
                    <>No Events Found</>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </Suspense>
  );
};

export default ShowAll;
